<template>
  <div class="navigation-bread-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ name: page.name, params: { threadId: $route.params.threadId }}">{{page.title}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{page.sub}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
  /*breadcrumb component based el-breadcrumb*/

  export default {
    name: "NavBread",
    props: {
      page: {
        type: Object
      }
    }
  };
</script>

<style>
  .navigation-bread-wrap {
    margin-bottom: 15px;
  }

  .nav-bread-kostil .el-breadcrumb__inner{
    font-weight: 500!important;
    text-decoration: none;
    -webkit-transition: color .2s cubic-bezier(.645,.045,.355,1);
    transition: color .2s cubic-bezier(.645,.045,.355,1);
    color: #409EFF!important;
    background-color: #ecf5ff;
    padding: 5px;
}
  .nav-bread-kostil .el-breadcrumb__inner.is-link{
    font-weight: 500!important;
    text-decoration: none;
    -webkit-transition: color .2s cubic-bezier(.645,.045,.355,1);
    transition: color .2s cubic-bezier(.645,.045,.355,1);
    color: black!important;
    background-color: white!important;
    padding: 5px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    font-weight: 500;
    text-decoration: none;
    -webkit-transition: color .2s cubic-bezier(.645,.045,.355,1);
    transition: color .2s cubic-bezier(.645,.045,.355,1);
    color: #409EFF!important;
    background-color: #ecf5ff;
    padding: 5px;
}
.el-breadcrumb__item:first-child .el-breadcrumb__inner, .el-breadcrumb__item:first-child .el-breadcrumb__inner a, .el-breadcrumb__item:first-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:first-child .el-breadcrumb__inner:hover {
    font-weight: 500;
}
</style>
